export const replaceIncorrectSymbols = (string) => {
  return string.replace(/â€\x9D/, "").replace(/\//, "").replace("”", "")
}

/**
 * @param value {number}
 * @param percent {number}
 * @returns {number}
 */
export const getPercentage = (value, percent) => {
  return (value / 100) * percent;
}

/**
 * common func for checking if need to show
 * @param fabricatorSettings {object}
 * @param forCartItems {array}
 * @return {array} // {currency: "USD", cartItems: []}
 */
export const getDifferentCurrencyCartItems = (fabricatorSettings, forCartItems = []) => {
  let totalArray = [];
  if (!fabricatorSettings.useDifferentCurrencies || !forCartItems.length) {
    return totalArray
  }
  forCartItems.forEach(cartItem => {
    if (cartItem.cartFeature && cartItem.cartFeature.getFeatureCurrency) {
      const featureCurrency = cartItem.cartFeature.getFeatureCurrency();
      if (featureCurrency && (featureCurrency !== fabricatorSettings.currency)) {
        const existingGroup = totalArray.find(filterGroupObject => {
          return filterGroupObject.currency === featureCurrency
        });
        if (existingGroup) {
          existingGroup.cartItems.push(cartItem);
        } else {
          totalArray.push({
            currency: featureCurrency,
            cartItems: [cartItem]
          })
        }
      }
    }
  });
  // console.log("totalArray", totalArray);
  return totalArray
}
